module.exports = __webpack_public_path__ + "static/media/scrollRight1.e20b2d5e.png";